(function () {

  function handleAddToCart(e) {
    e.preventDefault();

    var form = e.currentTarget;
    var btn = form.querySelector('button[type="submit"]');

    if (btn) {
      btn.textContent = 'Adding To Cart...';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.7';
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData(form);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function getSectionId(s) { return s.id; })
      );
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(function parseResponse(res) { return res.json(); })
      .then(function renderCart(response) {
        if (cart) cart.renderContents(response);
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      })
      .catch(function handleError(err) {
        console.error('Add to cart error:', err);
      })
      .finally(function resetButton() {
        if (btn) {
          btn.textContent = 'Add To Cart';
          btn.style.pointerEvents = 'unset';
          btn.style.opacity = '1';
        }
      });
  }

  function initProductCardForms(root) {
    var target = root || document;

    target.querySelectorAll('.product-card form[action$="/cart/add"]').forEach(function attachForm(form) {
      if (form.dataset.pcInitialized) return;
      form.dataset.pcInitialized = 'true';
      form.addEventListener('submit', handleAddToCart);
    });
  }

  function onDOMReady() {
    initProductCardForms();
  }

  document.addEventListener('DOMContentLoaded', onDOMReady);

  window.ProductCard = { init: initProductCardForms };

})();